import { queryOptions } from '@tanstack/react-query';

import { EQueryKeys } from '@enums/queryKeys.enum';
import { topicsImportFileSchema } from '@schemas/topicsImportFile.schema';
import { treatmentUpdatesService } from '@services/treatmentUpdates/service';
import type { GetTreatmentUpdateByIdOutput } from '@services/treatmentUpdates/types/getById.type';

import type { ContentEditorSettings } from './types';

export const treatmentUpdateEditorSettings = {
  api: {
    createMessage: ({ demandId, message }) =>
      treatmentUpdatesService.createMessage({
        message,
        treatmentUpdateId: demandId,
      }),
    createTopic: ({ content, demandId, position, title }) =>
      treatmentUpdatesService.createTopic({
        content,
        position,
        title,
        treatmentUpdateId: demandId,
      }),
    importTopics: ({ demandId, file }) =>
      treatmentUpdatesService.importTopics({
        file,
        treatmentUpdateId: demandId,
      }),
    markReview: demandId => treatmentUpdatesService.markReview(demandId),
    removeAllTopics: demandId =>
      treatmentUpdatesService.removeAllTopics({ treatmentUpdateId: demandId }),
    removeTopic: ({ demandId, id }) =>
      treatmentUpdatesService.removeTopic({ id, treatmentUpdateId: demandId }),
    reorderTopics: ({ demandId, ids }) =>
      treatmentUpdatesService.reorderTopics({
        ids,
        treatmentUpdateId: demandId,
      }),
    updateMessage: ({ demandId, message, messageId }) =>
      treatmentUpdatesService.updateMessage({
        message,
        treatmentUpdateId: demandId,
        treatmentUpdateMessageId: messageId,
      }),
    updateTopic: ({ content, demandId, id, title }) =>
      treatmentUpdatesService.updateTopic({
        content,
        id,
        title,
        treatmentUpdateId: demandId,
      }),
  },
  detailsQueryOptions: (id: string) =>
    queryOptions({
      queryKey: [EQueryKeys.TreatmentDetails, id],
      queryFn: () => treatmentUpdatesService.getById(id),
      select: data => data.treatment,
      staleTime: 1000 * 60,
      refetchOnWindowFocus: false,
    }),
  import: {
    fileSchema: topicsImportFileSchema,
  },
  labels: {
    noun: 'protocolo',
    title: 'Detalhes do protocolo',
  },
  listPath: '/my-treatments',
  page: '/new-treatments',
  refreshDetails: queryClient =>
    queryClient.invalidateQueries({
      queryKey: [EQueryKeys.TreatmentDetails],
    }),
  reviewQueryKeys: [
    [EQueryKeys.TreatmentDetails],
    [EQueryKeys.MyTreatmentUpdates],
    [EQueryKeys.MyTreatmentCreates],
    [EQueryKeys.Treatments],
  ],
} satisfies ContentEditorSettings<GetTreatmentUpdateByIdOutput>;
